type DamLibrarySort =
    | 'recentlyEdited'
    | 'recentlyViewed'
    | 'recentlyAdded'
    | 'fileName'
    | 'tagName'
    | 'uploadDate'
    | 'publishDate'
    | 'timeliness'
    | 'currency'
    | 'quality';

interface DamLibrarySortDefinition {
    key: DamLibrarySort;
    labelKey: string;
    /** Index field and direction; missing while the API cannot sort by it (LAX-10478, LAX-10479). */
    field?: string;
    direction?: 'asc' | 'desc';
}

const DEFAULT_DAM_LIBRARY_SORT: DamLibrarySort = 'recentlyEdited';

/** Sort menu of the wireframe (`6565:67559`), in menu order. */
const DAM_LIBRARY_SORTS: readonly DamLibrarySortDefinition[] = [
    { key: 'recentlyEdited', labelKey: 'DAM.LIBRARY.SORT.RECENTLY_EDITED', field: 'updatedAt__', direction: 'desc' },
    { key: 'recentlyViewed', labelKey: 'DAM.LIBRARY.SORT.RECENTLY_VIEWED' },
    { key: 'recentlyAdded', labelKey: 'DAM.LIBRARY.SORT.RECENTLY_ADDED', field: 'createdAt__', direction: 'desc' },
    { key: 'fileName', labelKey: 'DAM.LIBRARY.SORT.FILE_NAME', field: 'filename__', direction: 'asc' },
    { key: 'tagName', labelKey: 'DAM.LIBRARY.SORT.TAG_NAME' },
    { key: 'uploadDate', labelKey: 'DAM.LIBRARY.SORT.UPLOAD_DATE', field: 'createdAt__', direction: 'desc' },
    { key: 'publishDate', labelKey: 'DAM.LIBRARY.SORT.PUBLISH_DATE' },
    { key: 'timeliness', labelKey: 'DAM.LIBRARY.SORT.TIMELINESS' },
    { key: 'currency', labelKey: 'DAM.LIBRARY.SORT.CURRENCY' },
    { key: 'quality', labelKey: 'DAM.LIBRARY.SORT.QUALITY' },
];

const findDamLibrarySort = (key: string | undefined): DamLibrarySortDefinition | undefined =>
    DAM_LIBRARY_SORTS.find((sort) => sort.key === key);

const isDamLibrarySortAvailable = (sort: DamLibrarySortDefinition): boolean => Boolean(sort.field);

export { DAM_LIBRARY_SORTS, DEFAULT_DAM_LIBRARY_SORT, findDamLibrarySort, isDamLibrarySortAvailable };
export type { DamLibrarySort, DamLibrarySortDefinition };
